import { ref } from "vue";

export interface Toast {
  id: number;
  message: string;
  type: "success" | "error" | "info" | "warning";
  duration?: number;
}

const toasts = ref<Toast[]>([]);
let nextId = 1;

function dismissToast(id: number): void {
  const index = toasts.value.findIndex((t) => t.id === id);
  if (index !== -1) {
    toasts.value.splice(index, 1);
  }
}

export function useToast() {
  const show = (
    message: string,
    type: Toast["type"] = "info",
    duration = 3000,
  ) => {
    const toast: Toast = {
      id: nextId++,
      message,
      type,
      duration,
    };

    toasts.value.push(toast);

    if (duration > 0) {
      setTimeout(() => {
        dismissToast(toast.id);
      }, duration);
    }
  };

  const remove = (id: number) => {
    dismissToast(id);
  };

  const success = (message: string, duration?: number) => {
    show(message, "success", duration);
  };

  const error = (message: string, duration?: number) => {
    show(message, "error", duration);
  };

  const info = (message: string, duration?: number) => {
    show(message, "info", duration);
  };

  const warning = (message: string, duration?: number) => {
    show(message, "warning", duration);
  };

  return {
    toasts,
    show,
    remove,
    success,
    error,
    info,
    warning,
  };
}
